import { css } from "@emotion/core";
import { PropValuesEnum, color } from "../../constants/commons";

export const responsiveWidgetStyle = (
  align: PropValuesEnum.VERTICAL | PropValuesEnum.HORIZONTAL
) => css`
  display: flex;
  .responsive-widget-item {
    display: flex;
    min-width: 13em;
    margin-bottom: 1.5em;
  }

  ${align === PropValuesEnum.VERTICAL &&
  `flex-direction: column;
   .responsive-widget-item {
      flex-direction: row;
      align-items: center;
      margin-bottom: 2.2em;
    }
    img {
      margin-right: 1.9em;
    }
  `}

  ${align === PropValuesEnum.HORIZONTAL &&
  `flex-direction: row;
   text-align: center;
   .responsive-widget-item {
      flex-direction: column;
      // min-width: 16em;
      // margin-bottom: 1.5em;
      margin-right: 1em;
      flex: 1;
    }
   img {
      margin-bottom: 1.6em;
    }
   overflow-x: scroll;
   -ms-overflow-style: none;  /* IE and Edge */
   scrollbar-width: none;  /* Firefox */
   ::-webkit-scrollbar {
     display: none; /* Chrome, Safari and Opera */
    }
  `}
`;

export const cardContainerStyle = css`
  background: ${color.white};
  border-radius: 0.63em;
  box-shadow: 0 0.25em 0.63em 0 ${color.shadow};
  // min-width: 13.75em;
  // max-width: 17.3em;
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    padding: 2em 1em;
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    padding: 2em 1em;
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    padding: 2.5em 1.5em;
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    padding: 3em 2em;
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    padding: 3.2em 2.2em;
  }
`;
